import { render } from "./PreProgram.vue?vue&type=template&id=0a23170c&scoped=true"
import script from "./PreProgram.vue?vue&type=script&lang=js"
export * from "./PreProgram.vue?vue&type=script&lang=js"

import "./PreProgram.vue?vue&type=style&index=0&id=0a23170c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a23170c"]])

export default __exports__